import { render } from "./IconClose.vue?vue&type=template&id=67022532&scoped=true&ts=true"
import script from "./IconClose.vue?vue&type=script&lang=ts"
export * from "./IconClose.vue?vue&type=script&lang=ts"

import "./IconClose.vue?vue&type=style&index=0&id=67022532&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67022532"]])

export default __exports__